import React from "react";
import {
  Avatar,
  Box,
  Hidden,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { useHistory } from "react-router-dom";
import AA from "../../assets/images/AA.jpg";
import { useDispatch, useSelector } from "react-redux";
import SuccessModal from "./SuccessModal";
import Logo from "../../assets/images/logo.PNG";
import { setSection, toggleChangeLogoModal, toggleLoginModal } from "../../reducers/UiReducer";
import { agentloginSuccess } from "../../reducers/UserReducer";
import ErrorModal from "./ErrorModal";
import Login from "./Login";
import LoadingModal from "./LoadingModal";
const HeaderSection = () => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("sm"));
  const [header, SetHeader] = React.useState("onlineRecharge");
  const history = useHistory();
  const { section } = useSelector((state) => state.ui);
  const handleLogout= ()=>{
    dispatch(toggleChangeLogoModal(true))
    setTimeout(()=>{
      dispatch(toggleChangeLogoModal(false))
      history.push('/')
    },1200)
  }
  const handelHeader = (val) => {
    SetHeader(val);
  };
  const { logo, admin } = useSelector((state) => state.home);
  const { travellerlogin, agentlogin, walletagent, wallet, agentlogoget } =
    useSelector((state) => state.user);
  return (
    <>
      <Box
        style={{
          display: "flex",
          justifyContent: "flex-end",
          backgroundColor: "#0f3f5a",
          paddingRight: 80,
        }}
      >
        <Box
          style={{
            background: header === "onlineRecharge" ? "#ee8622" : "",
            padding: "4px 8px",
            cursor: "pointer",
          }}
          onClick={() => {
            handelHeader("onlineRecharge");
            history.push("/onlinerecharge");
          }}
        >
          <span style={{ color: "white" }}>Online Recharge</span>
        </Box>
        <Box
          style={{
            background: header === "contact" ? "#ee8622" : "",
            padding: "4px 8px",
          }}
          onClick={() => handelHeader("contact")}
        >
          <span style={{ color: "white" }}>Contact US</span>
        </Box>
        <Box
          style={{
            background: header === "logout" ? "#ee8622" : "",
            padding: "4px 8px",
            cursor:'pointer'
          }}
          onClick={() => {handelHeader("logout");handleLogout()}}
        >
          <span style={{ color: "white" }}>Logout</span>
        </Box>
      </Box>
      <Box
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          paddingLeft: 80,
          paddingRight: 80,
        }}
      >
          <Box
                onClick={() => history.push("/")}
                style={{ cursor: "pointer" }}
              >
                <img src={AA} style={{ height: 50 }}></img>
                <span
                  style={{
                    color: "#8b0000f2",
                    fontSize: "30px",
                    fontWeight: 600,
                    fontFamily: "cursive",
                  }}
                >
                  Arya Aviation
                </span>
              </Box>
        <Box style={{ display: "flex", alignItems: "center" }}>
          <p
            style={{
              marginTop: 0,
              marginBottom: 0,
              textAlign: "right",
              color: "#000",
              fontWeight: "bold",
            }}
          >
            {" "}
            Welcome Musafir bazar, AID7345{" "}
          </p>
          <Box style={{ display: "flex", marginLeft: 10 }}>
            <p>Credit Balance: </p>
            <span style={{color:'rgb(238, 134, 34)'}}>₹ 8574695 </span>
          </Box>
          <Box style={{ display: "flex", marginLeft: 10 }}>
            <p>Balance: </p>
            <span style={{color:'rgb(238, 134, 34)'}}>₹85000</span>
          </Box>
        </Box>
      </Box>
      <Box
        style={{
          display: "flex",
          justifyContent: "flex-end",
          backgroundColor: "white",
          paddingLeft: 80,
          paddingRight: 80,
        }}
      >
        <button
          onClick={() => history.push("/deals")}
          class="btn btn-secondary"
          type="button"
          id="dropdownMenu2"
          aria-expanded="false"
        >
          Hot Deals
        </button>
        <div class="dropdown">
          <button
            class="btn btn-secondary dropdown-toggle"
            type="button"
            id="dropdownMenu2"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            My Account
          </button>
          <div class="dropdown-menu" aria-labelledby="dropdownMenu2">
            <button
              class="dropdown-item"
              type="button"
              onClick={() => history.push("/booking")}
            >
              My Booking
            </button>
            <button
              class="dropdown-item"
              type="button"
              onClick={() => history.push("/transaction")}
            >
              My Transaction
            </button>
            <button
              class="dropdown-item"
              type="button"
              onClick={() => history.push("/bankdetails")}
            >
              Bank Details
            </button>
            <button
              class="dropdown-item"
              type="button"
              onClick={() => history.push("/onlinerecharge")}
            >
              Contact Us
            </button>
            <button
              class="dropdown-item"
              type="button"
              onClick={() => history.push("/onlinerecharge")}
            >
              Online Recharge
            </button>
            <button class="dropdown-item" type="button" onClick={() => history.push("/profile")}>
              Profile
            </button>
            <button class="dropdown-item" type="button" onClick={()=>history.push('/changepass')}>
              Change Password
            </button>
          </div>
        </div>
        <LoadingModal/>
        {/* </Box> */}
      </Box>
    </>
  );
};

export default HeaderSection;
